"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e, Fragment as g } from "react/jsx-runtime";
import * as n from "react";
import { useTheme as l } from "./hooks.js";
import { useIsInverseOrMediaVariant as u } from "./theme-variant-context.js";
import d from "./touchable.js";
import { getPrefixedDataAttributes as L } from "./utils/dom.js";
import { svg as f, logoContainer as h } from "./logo.css-mistica.js";
import { calcInlineVars as v } from "./logo-common.js";
import { applyCssVars as y } from "./utils/css.js";
const s = 48, T = /*#__PURE__*/ n.lazy(()=>import(/* webpackChunkName: "logo-movistar" */ "./logo-movistar.js")), I = /*#__PURE__*/ n.lazy(()=>import(/* webpackChunkName: "logo-vivo" */ "./logo-vivo.js")), N = /*#__PURE__*/ n.lazy(()=>import(/* webpackChunkName: "logo-o2" */ "./logo-o2.js")), p = /*#__PURE__*/ n.lazy(()=>import(/* webpackChunkName: "logo-o2-new" */ "./logo-o2-new.js")), k = /*#__PURE__*/ n.lazy(()=>import(/* webpackChunkName: "logo-telefonica" */ "./logo-telefonica.js")), O = /*#__PURE__*/ n.lazy(()=>import(/* webpackChunkName: "logo-blau" */ "./logo-blau.js")), V = /*#__PURE__*/ n.lazy(()=>import(/* webpackChunkName: "logo-tu" */ "./logo-tu.js")), i = (param)=>{
    let { size: o, skinName: r, type: t = "isotype" } = param;
    const a = u(), { isDarkMode: m } = l();
    switch(r){
        case "Movistar":
            return /* @__PURE__ */ e(T, {
                size: o,
                type: t,
                isDarkMode: m,
                isInverse: a
            });
        case "Vivo":
        case "Vivo-new":
            return /* @__PURE__ */ e(I, {
                size: o,
                type: t,
                isDarkMode: m,
                isInverse: a
            });
        case "O2":
            return /* @__PURE__ */ e(N, {
                size: o,
                type: t,
                isDarkMode: m,
                isInverse: a
            });
        case "O2-new":
            return /* @__PURE__ */ e(p, {
                size: o,
                type: t,
                isDarkMode: m,
                isInverse: a
            });
        case "Telefonica":
            return /* @__PURE__ */ e(k, {
                size: o,
                type: t,
                isDarkMode: m,
                isInverse: a
            });
        case "Blau":
            return /* @__PURE__ */ e(O, {
                size: o,
                type: t,
                isDarkMode: m,
                isInverse: a
            });
        case "Tu":
            return /* @__PURE__ */ e(V, {
                size: o,
                type: t,
                isDarkMode: m,
                isInverse: a
            });
        default:
            return /* @__PURE__ */ e(g, {});
    }
}, c = (o)=>{
    const r = L(o.dataAttributes, "Logo");
    return o.to || o.href || o.onPress ? /* @__PURE__ */ e(d, _object_spread({}, o)) : /* @__PURE__ */ e(n.Suspense, {
        fallback: /* @__PURE__ */ e("div", {
            className: f,
            style: _object_spread_props(_object_spread({}, y(v(o.size))), {
                width: 1
            })
        }),
        children: /* @__PURE__ */ e("div", _object_spread_props(_object_spread({
            className: h
        }, r), {
            children: o.children
        }))
    });
}, C = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    const { skinName: a } = l();
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: a,
            type: r,
            size: o
        })
    }));
}, E = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: "Movistar",
            type: r,
            size: o
        })
    }));
}, F = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: "Vivo",
            type: r,
            size: o
        })
    }));
}, H = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: "O2",
            type: r,
            size: o
        })
    }));
}, _ = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: "O2-new",
            type: r,
            size: o
        })
    }));
}, j = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: "Telefonica",
            type: r,
            size: o
        })
    }));
}, G = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: "Blau",
            type: r,
            size: o
        })
    }));
}, R = (_param)=>{
    var { size: o = s, type: r = "isotype" } = _param, t = _object_without_properties(_param, [
        "size",
        "type"
    ]);
    return /* @__PURE__ */ e(c, _object_spread_props(_object_spread({
        size: o
    }, t), {
        children: /* @__PURE__ */ e(i, {
            skinName: "Tu",
            type: r,
            size: o
        })
    }));
};
export { G as BlauLogo, C as Logo, E as MovistarLogo, H as O2Logo, _ as O2NewLogo, j as TelefonicaLogo, R as TuLogo, F as VivoLogo };
